import captchaStore from "@/store/captcha.js";

function initCaptcha() {
  if (!window.smartCaptcha || captchaStore.checkCookie()) return;

  window.smartCaptcha.render("captcha-container", {
    sitekey: process.env.VUE_APP_YANDEX_CAPTCHA_KEY,
    invisible: true,
    hideShield: true,
    callback: (token) => {
      captchaStore.setVerified(token);
    },
  });

  window.smartCaptcha.execute();
}

window.addEventListener("load", () => {
  if (window.smartCaptcha) {
    initCaptcha();
  }
});